export enum StockWarningType {
  NEGATIVE = "NEGATIVE",
  OUT_OF_STOCK = "OUT_OF_STOCK",
  BELOW_MIN = "BELOW_MIN",
  ABOVE_MAX = "ABOVE_MAX",
}
